import api from "../utils/api";
const API_URL = process.env.REACT_APP_API_URL;

export const getBugs = async () => {
  const response = await api.post(`${API_URL}/bugs.php`, {
    action: "getAll",
  });
  return response.data.bugs || [];
};
export const getBugsByProjectId = async (projectId) => {
  const response = await api.post(`${API_URL}/bugs.php`, {
    action: "getByProject",
    projectId,
  });
  return response.data.bugs || [];
};

export async function getBugById(id) {
  const response = await api.post(`${API_URL}/bugs.php`, {
    id,
    action: "get",
  });
  return response.data.bug;
}

export async function createBug(formData) {
  const response = await api.post(`${API_URL}/bugs.php`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function updateBug(formData) {
  const response = await api.post(`${API_URL}/bugs.php`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export const updateBugStatus = async (id, status) => {
  const response = await api.post(`${API_URL}/bugs.php`, {
    id,
    status,
    action: "updateStatus",
  });
  return response.data;
};

// Delete a task
export const deleteBug = async (id) => {
  const response = await api.post(`${API_URL}/bugs.php`, { id, action: "delete" });
  return response.data;
};

